import React from 'react';
import { IconProps } from './types';

export const DownChevron = ({ ...svgProps }: IconProps) => (
  <svg
    {...svgProps}
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 5L8 12L15 5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
